import { render, staticRenderFns } from "./VBarItemList.vue?vue&type=template&id=0879d3f2&scoped=true&"
import script from "./VBarItemList.vue?vue&type=script&lang=ts&"
export * from "./VBarItemList.vue?vue&type=script&lang=ts&"
import style0 from "./VBarItemList.vue?vue&type=style&index=0&id=0879d3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879d3f2",
  null
  
)

export default component.exports